import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  list: {
    base: css`
      list-style: none;
      margin: 0;
      padding-left: 0;
      ul {
        border-left: 1px solid var(--color-border-secondary);
        padding-left: var(--spacing-16);
      }
    `
  },
  node: {
    base: css`
      padding: 2px 0;
    `,
    value: css`
      ${kitText.style.bold}
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5em;
    `,
    label: css`
      display: inline-flex;
      align-items: center;
      gap: 0.5em;
      margin-right: var(--spacing-4);
    `
  }
};
